import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  FormGroup,
  Form,
  ModalHeader
} from 'reactstrap';

import { Link } from 'react-router-dom';

const CJobDetail = ({ data, deleteAction, viewLink, editLink }) => {
  const [open, setOpen] = useState(false);
  const [focusAfterClose, setFocusAfterClose] = useState(true);

  const toggle = () => setOpen(!open);
  const handleSelectChange = ({ target: { value } }) => {
    setFocusAfterClose(JSON.parse(value));
  };

  const skills = data?.skills;
  return (
    <>
      <div
        className='job--details'
        style={{ height: 'auto', minHeight: 'auto' }}
      >
        {/* Header */}
        <div className='header'>
          <div
            className='master--imageContainer lazyload'
            style={{
              backgroundImage: `url(${require('../../../assets/images/hero-header-bg.png')})`
            }}
          />
          <div className='actions'>
            {viewLink && (
              <Link
                type='button'
                className='btn edit'
                title='View Applicants'
                to={viewLink}
                data-original-title='View Applicants'
              >
                <i class='fas fa-users-cog'></i>{' '}
              </Link>
            )}
            {editLink && (
              <Link
                type='button'
                className='btn edit'
                title='Edit'
                to={editLink}
                data-original-title='Edit'
              >
                <i class='fas fa-edit'></i>
              </Link>
            )}
            {deleteAction && (
              <a
                type='button'
                className='btn trash'
                title='Delete'
                data-original-title='Delete'
                aria-describedby='tooltip694840'
                onClick={() => {
                  deleteAction(data._id);
                }}
              >
                <i class='fas fa-trash'></i>{' '}
              </a>
            )}
          </div>
        </div>
        {/* Content */}
        <div className='content custom--scrollbar'>
          <div>
            <div className='title'>{data.jobTitle}</div>
            <p>{data.jobDescription}</p>
          </div>

          <div className='title'>اعوام الخبرة: {data.yearsOfExperience}</div>
          <div className='title'>
            الخبرة غير ضرورية - يوجد تدريب علي الوظيفة:{' '}
            {data.trainingAvailable ? 'نعم' : 'لا'}
          </div>

          <div>
            <div className='title'>المهارات المطلوبة</div>
            <div className='tags'>
              {skills?.map((skill, index) => (
                <a type='button' className='btn btn-primary mr-2' key={index}>
                  {skill.skill}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div>
        <Modal returnFocusAfterClose={focusAfterClose} isOpen={open}>
          <ModalHeader>هل انت متاكد من مسح هذا العنصر</ModalHeader>
          <ModalFooter>
            <Button color='primary' onClick={toggle}>
              لا
            </Button>
            <Button
              color='danger'
              onClick={() => {
                deleteAction(data._id);
                toggle();
              }}
            >
              نعم
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default CJobDetail;
